import { render, staticRenderFns } from "./create-zip-button.vue?vue&type=template&id=a37c1a0a&"
import script from "./create-zip-button.vue?vue&type=script&lang=js&"
export * from "./create-zip-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports